/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IDocumentationFlagProps {
	flag: string;
}

const FLAG_LABELS: Record<string, string> = {
	"work-in-progress": "Work in Progress",
	"needs-review": "Needs Review",
	"outdated": "Outdated"
};

export const DocumentationFlag: React.FC<IDocumentationFlagProps> = ({ flag }) => {
	const baseClass = BEM("edt-documentation-content");

	return (
		<span
			className={baseClass.element("flag").add(`edt-documentation-content__flag--${flag}`).toClassName()}
		>
			{FLAG_LABELS[flag] || flag}
		</span>
	);
};
